import "react-app-polyfill/ie11"; /** Support IE11 */
import "react-app-polyfill/stable"; /** Support IE11 */
import React from 'react';
import ReactDOM from 'react-dom';
import AppProvider from './AppProvider';
import DocumentEducationView from '../src/content/EduDocumentationView';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('documentation-component');
  const data = JSON.parse(node.getAttribute('data'));

  ReactDOM.render(
    <AppProvider data={data}>
      <DocumentEducationView />
    </AppProvider>,
    document.getElementById('documentation-component')
  )
});
